import { useQuery } from "@tanstack/react-query";
import { getProduct } from "api";

// eslint-disable-next-line
const useQueryProduct = (id: string, options?: any) => {
  return useQuery(["product"], () => getProduct(id), options);
};

export default useQueryProduct;
